import { render } from "./AdditionEditTermination.vue?vue&type=template&id=c2adb93a"
import script from "./AdditionEditTermination.vue?vue&type=script&lang=js"
export * from "./AdditionEditTermination.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__